import React from "react";

import { RouteProps } from "react-router-dom";

import {
  Login,
  ForgotPassword,
  ChangePassword,
  UserList,
  EducationConsultationList,
  CreateConsentStatement,
  Setting,
  NursingHomeRegistration,
  RegistrationByPhoneNumber,
  AccountRegistration,
  DownloadAppNQR,
  VerifyOTP,
  Dashboard,
  Dashboard2,
  MessageDelivery,
  HistoryList,
  Dashboard4,
  ResourcesDownload,
  ForgotPasswordNotification,
  ResetPassword,
  ResetPasswordNotification,
} from "screens";
import { MainLayout, DashboardLayout, SubLayout, SpecialLayout } from "layouts";

export interface IRoute extends RouteProps {
  restricted?: boolean;
  layout?: React.ComponentType;
}

interface IConfigRoutes {
  appRoutes: IRoute[];
  isPrivate?: boolean;
  layout?: React.ComponentType;
}

export const privateRoutes: IRoute[] = [
  {
    children: <UserList />,
    path: "/user-list",
    // layout: DashboardLayout,
  },
  {
    children: <EducationConsultationList />,
    path: "/education-consultation-list",
    // layout: DashboardLayout,
  },
  {
    children: <CreateConsentStatement />,
    path: "/create-consent-statement",
    // layout: DashboardLayout,
  },
  {
    children: <MessageDelivery />,
    path: "/message-delivery",
    // layout: DashboardLayout,
  },
  {
    children: <HistoryList />,
    path: "/message-delivery/history",
    // layout: DashboardLayout,
  },
  {
    children: <ChangePassword />,
    path: "/change-password",
    // layout: DashboardLayout,
  },
  {
    children: <Setting />,
    path: "/settings",
    // layout: DashboardLayout,
  },
  {
    children: <Dashboard4 />,
    path: "/dashboard",
    // layout: DashboardLayout,
  },
  {
    children: <ResourcesDownload />,
    path: "/resources-download",
    // layout: DashboardLayout,
  },

  // {
  //   children: <ReservationDetails />,
  //   path: "/reservation-details/:reservationId",
  //   layout: DashboardLayout,
  // },
];

export const publicRoutes: IRoute[] = [
  {
    children: <Login />,
    path: "/login",
    // layout: MainLayout,
    restricted: true,
  },
  {
    children: <ForgotPassword />,
    path: "/forgot-password",
    // layout: MainLayout,
    restricted: true,
  },
  {
    children: <ForgotPasswordNotification />,
    path: "/forgot-password-notification",
    // layout: MainLayout,
    restricted: true,
  },
  {
    children: <ResetPassword />,
    path: "/reset-password",
    // layout: MainLayout,
    restricted: false,
  },
  {
    children: <ResetPasswordNotification />,
    path: "/reset-password-notification",
    // layout: MainLayout,
    restricted: true,
  },
];

export const subRoutes: IRoute[] = [
  {
    children: <NursingHomeRegistration />,
    path: "/personalregistration/SII",
    // layout: SubLayout,
  },
  {
    children: <RegistrationByPhoneNumber />,
    path: "/verify-phone-number",
    // layout: SubLayout,
  },
  {
    children: <AccountRegistration />,
    path: "/account-registration",
    layout: SpecialLayout,
  },
  {
    children: <DownloadAppNQR />,
    path: "/download-app-qr",
    // layout: SubLayout,
  },
  {
    children: <VerifyOTP />,
    path: "/verify-otp",
    // layout: SubLayout,
  },
];

export const configRoutes: IConfigRoutes[] = [
  {
    appRoutes: privateRoutes,
    isPrivate: true,
    layout: MainLayout,
  },
  {
    appRoutes: publicRoutes,
    layout: MainLayout,
  },
];

export const layouts = {
  dashboard: DashboardLayout,
  main: MainLayout,
  sub: SubLayout,
};
